module.exports = __webpack_public_path__ + "media/app/assets/races/pandaren_female-e5359264412e50d62e0f9e97600350a7.png";